import { ItemRestriction, OPERATORS } from 'typings'
import { SCOPE_OPTIONS } from '../../../../ItemsView/typing'
import { RegularScope, RegularScopeApplyTo } from '../../../../../typings'

export const EMPTY_SCOPE_RESTRICTION: ItemRestriction = {
  items: [],
  operator: OPERATORS.EQUALS,
}

export const EMPTY_SCOPE: RegularScope = {
  applyTo: RegularScopeApplyTo.allItems,
  [SCOPE_OPTIONS.SKUS]: undefined,
  [SCOPE_OPTIONS.BRANDS]: undefined,
  [SCOPE_OPTIONS.CATEGORIES]: undefined,
  [SCOPE_OPTIONS.COLLECTIONS]: undefined,
  [SCOPE_OPTIONS.PRODUCTS]: undefined,
}
